import { BulkDiscountClient, Cart, Lineitem } from 'types';
import { i18nStore } from 'contexts/i18n';
import { convertCurrencyToNumber } from 'components/OrderDetails';

export const isCartHavingDiscountedProducts = (cart: Cart) => {
  return (
    cart.displayLineItemsTotalWithDiscounts !==
    cart.displayLineItemsTotalWithoutDiscount
  );
};

export const bulkDiscountText = (
  i18n: i18nStore,
  lineItem: Lineitem,
  bulkDiscount?: BulkDiscountClient
) => {
  if (lineItem.isHavingSubsriptionAdjustments) {
    return '';
  }
  if (bulkDiscount && lineItem.isHavingBulkDiscountAdjustments) {
    return i18n['Applied'];
  } else if (bulkDiscount) {
    return i18n['Not Applied'];
  } else {
    return '';
  }
};

export const isAllLineItemsPriceValid = (cart: Cart) => {
  if (cart.lineItems.length === 0) {
    return false;
  }

  return cart.lineItems.every(
    item => convertCurrencyToNumber(item.displayTotal) >= 0
  );
};
